import React from 'react';

import styles from './FormGroup.module.css';

import type { ReactElement } from 'react';

type Props = {
  children: React.ReactNode;
};

export const FormGroup = ({ children }: Props): ReactElement => (
  <div className={styles.root}>{children}</div>
);
